import { registerComponent, asyncRequest, debounce, loading } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "cart-items",
  class CartItems extends WYATTElement {
    SECTIONS_TO_RENDER = [
      {
        name: "cart-count",
        liveRegion: "cart-count",
      },
      {
        name: "cart",
        liveRegion: "cart-items",
      },
      {
        name: "cart",
        liveRegion: "cart-totals",
      },
      {
        name: "cart",
        liveRegion: "cart-checkout",
      },
      {
        name: "cart",
        liveRegion: "cart-recommendations",
      },
    ];

    constructor() {
      super();

      this.removeButtons = this.querySelectorAll("[data-remove-item-button]");
      this.form = this.querySelector("form");
      this.quantityInputs = this.querySelectorAll('[name="updates[]"]');
      this.currentItemCount = Array.from(
        this.querySelectorAll('[name="updates[]"]'),
      ).reduce(
        (total, quantityInput) => total + parseInt(quantityInput.value, 10),
        0,
      );

      this.removeButtons.forEach((button) => {
        button.addEventListener("click", this.remove.bind(this));
      });

      const debouncedQuantityChangeHandler = debounce((event) => {
        this.handleQuantityChange(event);
      }, 300);

      this.quantityInputs.forEach((input) => {
        input.addEventListener("change", debouncedQuantityChangeHandler);
      });

      this.subscribe(
        WYATT.PubSub.events.lineItemNoteChange,
        this.handleNoteChange.bind(this),
      );

      // this.form?.addEventListener("change", debouncedQuantityChangeHandler);
    }

    remove(event) {
      const line = event.currentTarget.dataset.removeItemButton;

      event.preventDefault();

      this.updateItem(line, { quantity: 0 });
    }

    handleQuantityChange(event) {
      const { target } = event;
      const { lineItemIndex } = target.dataset;
      const data = { quantity: target.value };

      this.updateItem(lineItemIndex, data);
    }

    handleNoteChange(event) {
      const { lineItemIndex, notes, quantity } = event.detail;
      this.updateItem(lineItemIndex, {
        quantity,
        properties: { Notes: notes },
      });
    }

    getSectionNames() {
      return [
        ...new Set(this.SECTIONS_TO_RENDER.map((section) => section.name)),
      ];
    }

    async updateItem(line, data) {
      const body = {
        line,
        ...data,
        sections: this.getSectionNames(),
        sections_url: window.location.pathname,
      };
      const options = {
        ...WYATT.config.fetch.post,
        ...{ body: JSON.stringify(body) },
      };

      loading.add(this);

      const response = await asyncRequest(
        WYATT.routes.cart_change_url,
        options,
        {
          messageOptions: {
            minDelay: 6000,
            appendPoint:
              '[data-mini-cart][active="true"] [data-dialog-messages], #page-messages',
          },
        },
      );

      if (response) {
        this.handleSuccessfulUpdate(response);
      }

      loading.remove(this);
    }

    handleSuccessfulUpdate(state) {
      const parsedState = JSON.parse(state);

      this.publish(
        WYATT.PubSub.events.updateDOM,
        this.SECTIONS_TO_RENDER.map(({ liveRegion, name }) => ({
          liveRegion,
          html: parsedState.sections[name],
        })),
      );
    }
  },
);
